import React from 'react';

const Awardme = () => {
    return (
        <div className="award">
            <div className="award-in">
                <p style={{paddingBottom:"20px",paddingTop:"20px",textTransform:"uppercase"}}>I have completed Programming hero Full Stack web dev.</p>
                {/* <embed className="award-embed" src="documents/Programminghero.pdf" /> */}
                <object className="award-embed" data="documents/Programminghero.pdf" type="application/pdf">
                    <p>Your web browser doesn't have a PDF plugin.
                        <a href="https://drive.google.com/uc?export=download&id=1pAnjnpGnHCt2n5m1PXWt7n-S7XdEH8OV" target="_blank" rel="noopener noreferrer">click here to download the PDF file.</a></p>
                </object>
            </div>
            <div className="award-in">
            <p style={{paddingBottom:"20px",paddingTop:"20px",textTransform:"uppercase"}}>I have completed Front end Web development altimate course 2021 (91 hours).of Udemy</p>
                {/* <embed className="award-embed" src="documents/frontEnd.pdf" /> */}
                <object className="award-embed" data="documents/frontEnd.pdf" type="application/pdf">
                    <p>Your web browser doesn't have a PDF plugin.
                        <a href="https://drive.google.com/uc?export=download&id=1pAnjnpGnHCt2n5m1PXWt7n-S7XdEH8OV" target="_blank" rel="noopener noreferrer">click here to download the PDF file.</a></p>
                </object>
            </div>
            <div className="award-in">
            <p style={{paddingBottom:"20px",paddingTop:"20px",textTransform:"uppercase"}}>I have completed the course of google search , time is sort but course is powerful . supper one. showing how to search google to find out anything easly.</p>
                {/* <embed className="award-embed" src="documents/googleSearch.pdf" /> */}
                <object className="award-embed" data="documents/googleSearch.pdf" type="application/pdf">
                    <p>Your web browser doesn't have a PDF plugin.
                        <a href="https://drive.google.com/uc?export=download&id=1pAnjnpGnHCt2n5m1PXWt7n-S7XdEH8OV" target="_blank" rel="noopener noreferrer">click here to download the PDF file.</a></p>
                </object>
            </div>
            <div className="award-in">
            <p style={{paddingBottom:"20px",paddingTop:"20px",textTransform:"uppercase"}}>I have completed Css animation and transition tutorial. good one.</p>
                {/* <embed className="award-embed" src="documents/animation_taransition.pdf" /> */}
                <object className="award-embed" data="documents/animation_taransition.pdf" type="application/pdf">
                    <p>Your web browser doesn't have a PDF plugin.
                        <a href="https://drive.google.com/uc?export=download&id=1pAnjnpGnHCt2n5m1PXWt7n-S7XdEH8OV" target="_blank" rel="noopener noreferrer">click here to download the PDF file.</a></p>
                </object>
            </div>

            {/* <object data="./filename.pdf" type="application/pdf">
  <p>Your web browser doesn't have a PDF plugin.
   <a href="#">click here to download the PDF file.</a></p>
</object> */}

        </div>
    );
};

export default Awardme;